import { LoadIdentifier } from '../../../shipment-load/models';

export class ShipmentLoadTrackingMapLoad {
  public static readonly type = '[ShipmentLoadTrackingMap] Load';
  constructor(public payload: LoadIdentifier) {}
}

export class ShipmentLoadTrackingMapInitialState {
  public static readonly type = '[ShipmentLoadTrackingMap] Set Initial State';
}
